import { GenericTable } from './GenericTable';
import { constrainedProgramsColumns } from '../../constants/tableRows';
import { MdDelete, MdContentCopy } from 'react-icons/md';

type RowData = Record<string, React.ReactNode>;

export function ConstrainedProgramsTable({ 
  onAdd, 
  data, 
  onEdit, 
  onDelete, 
  onCopy 
}: { 
  onAdd: () => void, 
  data: RowData[]; 
  onEdit?: (row: RowData) => void;
  onDelete?: (row: RowData) => void;
  onCopy?: (row: RowData) => void;
}) {
  const actions = [
    {
      key: 'delete',
      label: 'Delete',
      icon: <MdDelete />,
      onClick: onDelete || (() => {}),
      colorScheme: 'red'
    },
    {
      key: 'copy',
      label: 'Make Copy',
      icon: <MdContentCopy />,
      onClick: onCopy || (() => {})
    }
  ];

  return (
    <>
      <GenericTable 
        columns={constrainedProgramsColumns} 
        data={data} 
        title='programs' 
        onAdd={onAdd} 
        onEdit={onEdit}
        actions={actions}
      />
    </>
  );
}